import { Injectable } from '@angular/core';
import {
  CanLoad, CanActivate, Route, Router,
  ActivatedRouteSnapshot, RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { RoleAccessService } from './role.access.service';
import { CommonService } from './app.common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanLoad, CanActivate {
  constructor(private authService: AuthenticationService, private router: Router, public roleService: RoleAccessService, public common: CommonService) {
  }
  canLoad(route: Route): boolean {
    const url: string = route.path ?? "";
    if (this.authService.isUserLoggedIn()) {
      return true;
    }

    this.authService.setRedirectUrl(url);
    let redirectUrl = this.authService.getLoginUrl();
    const token = this.common.GetFromLocalStorage('auth_token');
    redirectUrl += '?gaurdRedirect=true&dateTime=' + new Date() + '&tokenExpiry=' + this.authService.GetTokenExpirationDate() + '&token=' + token;
    this.router.navigateByUrl(redirectUrl);
    return false;


  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {



    const url: string = state.url;
    if (this.authService.isUserLoggedIn()) {
      if (this.authService.isUserPasswordChange()) {
        this.router.navigate(['ForcePasswordChange']);
        return false;
      } else {
        return true;
      }
    }
    this.authService.setRedirectUrl(url);
    let redirectUrl = this.authService.getLoginUrl();
    const token = this.common.GetFromLocalStorage('auth_token');
    redirectUrl += '?gaurdRedirect=true&dateTime=' + new Date() + '&tokenExpiry=' + this.authService.GetTokenExpirationDate() + '&token=' + token;
    this.router.navigateByUrl(redirectUrl);
    return false;


  }




  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // console.log("Guarding children...");
    return this.canActivate(route, state);
  }

  protected hasRequiredPermission(): Promise<boolean> | boolean {
    // If user’s permissions already retrieved from the API

    if (this.roleService.IsPermissionsExists()) {

      return true;
    } else {
      // Otherwise, must request permissions from the API first
      const promise = new Promise<boolean>((resolve, reject) => {
        this.roleService.initializePermissions()
          .then(() => {
            resolve(true);
          }).catch(() => {
            resolve(false);
          });
      });
      return promise;
    }
  }
}
